import React from 'react';
import {Button, Layout, Result} from 'antd';
import {SmileOutlined, CloseCircleOutlined, ExclamationCircleOutlined} from '@ant-design/icons';
import HeaderMember from './HeaderMember';
import MenuDashboard from './Menu';
import {t} from '../../constant/i18n';
import './css/dashboard.css';

class StripeReturn extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            idCmd: this.props.match.params.idCmd,
            type: this.props.type,
        };
    }

    getReturnCode = () => {
        const search = this.props.location && this.props.location.search;
        if (!search) return null;
        const params = new URLSearchParams(search);
        return params.get('code') || params.get('error') || null;
    }

    renderResult = () => {
        const url = '/ident/order/' + this.state.idCmd;
        const btnEnd = (
            <Button type="primary" key="back" href={url}>
                {t('stripeReturn.backToOrder')}
            </Button>
        );

        const code = this.getReturnCode();

        if (this.state.type === 'success') {
            return (
                <Result
                    icon={<SmileOutlined/>}
                    status="success"
                    title={t('stripeReturn.successTitle')}
                    subTitle={t('stripeReturn.successSubtitle')}
                    extra={btnEnd}
                />
            );
        }

        if (this.state.type === 'cancel') {
            switch (code) {
                case 'card_declined':
                    return (
                        <Result
                            icon={<CloseCircleOutlined/>}
                            status="error"
                            title={t('stripeReturn.cardDeclinedTitle')}
                            subTitle={t('stripeReturn.cardDeclinedSubtitle')}
                            extra={btnEnd}
                        />
                    );
                case 'expired':
                case 'expired_card':
                    return (
                        <Result
                            icon={<ExclamationCircleOutlined/>}
                            status="warning"
                            title={t('stripeReturn.expiredTitle')}
                            subTitle={t('stripeReturn.expiredSubtitle')}
                            extra={btnEnd}
                        />
                    );
                case 'insufficient_funds':
                    return (
                        <Result
                            icon={<CloseCircleOutlined/>}
                            status="error"
                            title={t('stripeReturn.insufficientFundsTitle')}
                            subTitle={t('stripeReturn.insufficientFundsSubtitle')}
                            extra={btnEnd}
                        />
                    );
                case 'incorrect_cvc':
                    return (
                        <Result
                            icon={<CloseCircleOutlined/>}
                            status="error"
                            title={t('stripeReturn.incorrectCvcTitle')}
                            subTitle={t('stripeReturn.incorrectCvcSubtitle')}
                            extra={btnEnd}
                        />
                    );
                case 'incorrect_number':
                    return (
                        <Result
                            icon={<CloseCircleOutlined/>}
                            status="error"
                            title={t('stripeReturn.incorrectNumberTitle')}
                            subTitle={t('stripeReturn.incorrectNumberSubtitle')}
                            extra={btnEnd}
                        />
                    );
                case 'processing_error':
                    return (
                        <Result
                            icon={<ExclamationCircleOutlined/>}
                            status="warning"
                            title={t('stripeReturn.processingErrorTitle')}
                            subTitle={t('stripeReturn.processingErrorSubtitle')}
                            extra={btnEnd}
                        />
                    );
                case 'authentication_required':
                    return (
                        <Result
                            icon={<ExclamationCircleOutlined/>}
                            status="warning"
                            title={t('stripeReturn.authRequiredTitle')}
                            subTitle={t('stripeReturn.authRequiredSubtitle')}
                            extra={btnEnd}
                        />
                    );
                case 'do_not_honor':
                case 'generic_decline':
                    return (
                        <Result
                            icon={<CloseCircleOutlined/>}
                            status="error"
                            title={t('stripeReturn.doNotHonorTitle')}
                            subTitle={t('stripeReturn.doNotHonorSubtitle')}
                            extra={btnEnd}
                        />
                    );
                case 'lost_card':
                case 'stolen_card':
                    return (
                        <Result
                            icon={<CloseCircleOutlined/>}
                            status="error"
                            title={t('stripeReturn.unusableCardTitle')}
                            subTitle={t('stripeReturn.unusableCardSubtitle')}
                            extra={btnEnd}
                        />
                    );
                case 'try_again_later':
                    return (
                        <Result
                            icon={<ExclamationCircleOutlined/>}
                            status="warning"
                            title={t('stripeReturn.tryAgainTitle')}
                            subTitle={t('stripeReturn.tryAgainSubtitle')}
                            extra={btnEnd}
                        />
                    );
                case 'cancelled':
                    return (
                        <Result
                            status="warning"
                            title={t('stripeReturn.cancelledTitle')}
                            subTitle={t('stripeReturn.cancelledSubtitle')}
                            extra={btnEnd}
                        />
                    );
                default:
                    return (
                        <Result
                            status="warning"
                            title={t('stripeReturn.notFinalizedTitle')}
                            subTitle={
                                <span>
                                    {t('stripeReturn.notFinalizedSubtitle')}
                                    {code && <><br/><small>{t('stripeReturn.returnCode')} {code}</small></>}
                                </span>
                            }
                            extra={btnEnd}
                        />
                    );
            }
        }

        return (
            <Result
                status="error"
                title={t('stripeReturn.errorTitle')}
                subTitle={t('stripeReturn.errorSubtitle')}
                extra={btnEnd}
            />
        );
    }

    render() {
        return (
            <Layout>
                <HeaderMember/>
                <Layout>
                    <MenuDashboard/>
                    <div className="contentBox">
                        {this.renderResult()}
                    </div>
                </Layout>
            </Layout>
        );
    }
}

export default StripeReturn;
